import React, { useState, useEffect, useRef } from "react";
import { AudioRecorder } from "react-audio-voice-recorder";
import CustomDropdown from "./CustomDropdown";
import { chatbotsettings, getBase64, getFileTypeLabel } from "../../Functions/Utils";
import audioBufferToWav from "audiobuffer-to-wav";
import { toast } from "react-toast";

function ChatInputField({
  placeholder,
  onSendMessage,
  isTyping,
  hasAttachment,
  hasAttachFileOption,
  hasVoiceOption,
  hasLanguageOption,
  selectedLanguage,
  languageOptions,
  onLanguageChange,
  selectedVersion
}) {
  const [inputValue, setInputValue] = useState("");
  const [dots, setDots] = useState(""); // State to manage dots animation
  const [dynamicPlaceholder, setDynamicPlaceholder] = useState(placeholder); // Placeholder state
  const [files, setFiles] = useState([]);
  const [audioData, setAudioData] = useState("");
  const [inputpad, setInputpad] = useState(20);
  const fileInputRef = useRef(null);

  useEffect(() => {
    let interval;
    if (isTyping) {
      // Start animation when bot is typing
      interval = setInterval(() => {
        setDots((prev) => (prev.length < 3 ? prev + "." : "")); // Animate dots from 1 to 3 and back to empty
      }, 500);
      setDynamicPlaceholder(`Generating response${dots}`); // Update placeholder with animated dots
    } else {
      setDynamicPlaceholder(placeholder); // Reset placeholder when typing is done
    }

    return () => clearInterval(interval); // Cleanup on unmount or when isTyping changes
  }, [isTyping, dots, placeholder]);

  useEffect(() => {
    if (!hasAttachFileOption) {
      setFiles([]);
    }
  }, [hasAttachFileOption]);

  useEffect(() => {}, [audioData]);

  useEffect(() => {
    let pad = 20;
    (chatbotsettings?.enableLanguageforVoice && hasLanguageOption) && (pad = pad+55);
    (chatbotsettings?.enableVoiceRecording && hasVoiceOption) &&  (pad = pad+ 25);
    (chatbotsettings?.enableAttachments && hasAttachFileOption) &&  (pad = pad+ 25);
    setInputpad(pad);
  }, [chatbotsettings, hasLanguageOption,hasVoiceOption,hasAttachFileOption]);
  


  if (files.length > 0) {
    hasAttachment(true);
  } else {
    hasAttachment(false);
  }

  const handleSubmit = async (type, blob) => {
    let audioData = "";
    let audioDataWav = "";
    if (type === "audio") {
      if (blob) {
        const audioContext = new AudioContext();
        // Convert WebM Blob to AudioBuffer
        const arrayBuffer = await blob.arrayBuffer();
        const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
        // Convert AudioBuffer to WAV format
        const wavBuffer = audioBufferToWav(audioBuffer);
        const wavBlob = new Blob([wavBuffer], { type: 'audio/wav' });
        audioDataWav = await getBase64(wavBlob);
        audioData = URL.createObjectURL(blob);
      }
    } else {
      if (inputValue.trim() == "") {
        return;
      }
    }
    onSendMessage(inputValue, audioData,audioDataWav, files);
    setInputValue(""); // Clear input after sending
    setFiles([]);
  };

  const addAudioElement = async (blob) => {
    handleSubmit("audio", blob);
  };

  const handleFileChange = (event) => {
    if (event.target.files) {
      const selectedFiles = Array.from(event.target.files);
    // Filter files to only include those with supported formats
    const supportedFiles = selectedFiles.filter((file) => {
      const fileExtension = file.name.split('.').pop().toLowerCase(); // Get file extension in lowercase
      const isSupported = selectedVersion.attachOption.includes(fileExtension);
      if (!isSupported) {
        toast.error(`Warning: ${file.name} is not a supported format and has been removed.`);
      }
      return isSupported;
    });
    setFiles(supportedFiles);
    fileInputRef.current.value = "";
      //setFiles([...files, ...supportedFiles]); // Append new files to the existing list
    }
  };
  const removeFile = (index) => {
    setFiles(files.filter((_, i) => i !== index));
  };

  // const getFileType = (type) => {
  //   return type.split("/")[1];
  // };

  const renderFilePreviews = () => {
    return files.map((file, index) => {
      const isImage = file.type.startsWith("image/");
      const fileUrl = URL.createObjectURL(file);

      return (
        <div key={index} className="position-relative mb-2 mt-3">
          {isImage ? (
            <div
              className="bd_gray3 border overflow-hidden rounded bg-white"
              style={{ width: 55, height: 49 }}
            >
              <img
                src={fileUrl}
                alt={file.name}
                className="h-100 object-fit-cover w-100"
              />
            </div>
          ) : (
            <div className="bg_gray15 d-flex gap-2 p-2 rounded align-items-center">
              <span>
                <i className="far fa-file-alt p-2 rounded-1 text-bg-danger"></i>
              </span>
              <div>
                <p className="font_12 fw_500 lh-1 line_control_1 max_w_110x mb-0 min_w_80x overflow-hidden w-100 pe-2">
                  {file.name}
                </p>
                <span className="font_10 lh-1 d-inline-block line_control_1 max_w_100x overflow-hidden">
                  {getFileTypeLabel(file.type)}
                </span>
              </div>
            </div>
          )}
          <i
            className="bg-body-secondary circle_27x cursor-pointer fa-times fas position-absolute px-2 px_hover_1 rounded-circle"
            style={{ padding: "7px 0", top: "-11px", right: "-11px" }}
            onClick={() => removeFile(index)}
          ></i>
        </div>
      );
    });
  };

  // const handleLanChange = (version) => {
  //   setSelectedLanguage(version);
  // };

  return (
    <div>
      {files.length > 0 && (
        <div className="d-flex gap-3 overflow-auto scrollbar1 mb-2">
          {renderFilePreviews()}
        </div>
      )}
      <div
        className={
          isTyping
            ? `input_withicon end h_lg chat_textbox disable_div`
            : `input_withicon end h_lg chat_textbox`
        }
      >
        {(hasLanguageOption && chatbotsettings?.enableLanguageforVoice) &&
          <div className="language__wrapper">
            <CustomDropdown
              dropdownType="language"
              selectedOption={selectedLanguage}
              options={languageOptions}
              onOptionChange={onLanguageChange}
            />
          </div>
        }
        {(hasVoiceOption && chatbotsettings?.enableVoiceRecording) &&
          <AudioRecorder
            classes={{
              AudioRecorderClass: "audio__wrapper",
            }}
            onRecordingComplete={addAudioElement}
            audioTrackConstraints={{
              noiseSuppression: true,
              echoCancellation: true,
            }}
            onNotAllowedOrFound={(err) => console.table(err)}
            //downloadOnSavePress={true}
            downloadFileExtension="wav"
            mediaRecorderOptions={{
              audioBitsPerSecond: 128000,
            }}
            // showVisualizer={true}
          />
        }
        {(hasAttachFileOption && chatbotsettings?.enableAttachments) && (
          <div className="position-absolute gap-1 d-flex attch__icon">
            <div className="mt-1 pt-2">
              <input
                type="file"
                id="file-input"
                accept=".pdf,.docs"
                //multiple
                onChange={handleFileChange}
                ref={fileInputRef} 
                style={{ display: "none"}}
              />
              <label
                htmlFor="file-input"
                className="attachment-icon text_dark1"
              >
                <i className="fas fa-paperclip py-2 px-1 cursor-pointer px_hover_1"></i>
              </label>
            </div>
          </div>
        )}
        <input
          type="text"
          className="form-control font_13 with_icon"
          placeholder={dynamicPlaceholder} // Dynamic placeholder
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyPress={(e) => e.key === "Enter" && handleSubmit("", "")} // Send on Enter key
          disabled={isTyping} // Disable input while bot is typing
          style={{ cursor: isTyping ? "not-allowed" : "text", paddingLeft: inputpad || 20  }} // Change cursor style when disabled
        />
        <i
          className={`fas fa-location-arrow icn mt-2 p-2 cursor-pointer px_hover_1 ${
            isTyping ? "text-muted" : ""
          }`}
          onClick={() => {
            handleSubmit("", "");
          }}
          style={{
            pointerEvents: isTyping ? "none" : "auto",
            cursor: isTyping ? "not-allowed" : "pointer",
          }} // Disable click when typing
        ></i>
      </div>
    </div>
  );
}

export default ChatInputField;
